export default __webpack_public_path__ + "static/media/right_corner.6ab30d2d.png";